import React, {Component} from 'react';
import '../css/views/booking-common.css';
import '../css/theme/mainContent.css';
import '../css/theme/forms.css';
import '../css/theme/forms-block.css';
import '../css/theme/buttons.css';
import {createLogoutOnFailureHandler} from "../util/LogoutUtil";
import Busy from "./Busy";
import {toast} from 'react-toastify';
import DatePicker from "./DatePicker";
import {Booking} from "../types/Booking";

interface JQueryXHR {
    responseJSON?: { message?: string };
}

interface JQueryAjaxOptions {
    url: string;
    data: string;
    type: string;
    contentType: string;
    dataType: string;
    success: (booking: Booking) => void;
    statusCode: { [statusCode: number]: () => void };
    error: (jqXHR: JQueryXHR) => void;
}

interface JQueryStatic {
    ajax: (options: JQueryAjaxOptions) => void;
}

const $ = (window as unknown as { $: JQueryStatic }).$;

interface AdjustBookingDatesFormProps {
    booking: Booking;
    display?: string;
    onSuccess: (booking: Booking) => void;
    closeSubViewHandler: () => void;
}

interface AdjustBookingDatesFormState {
    endDate: string;
}

class AdjustBookingDatesForm extends Component<AdjustBookingDatesFormProps, AdjustBookingDatesFormState> {
    constructor(props: AdjustBookingDatesFormProps) {
        super(props);

        this.state = {
            endDate: this.props.booking.endDate
        };
    }

    handleFieldChange = (event: React.ChangeEvent<HTMLInputElement> | unknown): void => {
        const target = (event as React.ChangeEvent<HTMLInputElement>).target;
        const name = target.name;
        const value = target.value;

        this.setState({[name]: value} as Pick<AdjustBookingDatesFormState, keyof AdjustBookingDatesFormState>);
    };

    submitForm = (): void => {
        Busy.set(true);

        $.ajax({
            url: 'api/booking/adjust-dates',
            data: JSON.stringify({
                bookingId: this.props.booking.id,
                endDate: this.state.endDate
            }),
            type: 'POST',
            contentType: 'application/json; charset=UTF-8',
            dataType: "json",
            success: (booking) => {
                Busy.set(false);
                this.props.onSuccess(booking);
            },
            statusCode: {
                401: createLogoutOnFailureHandler()
            },
            error: (jqXHR) => {
                Busy.set(false);
                const errorMessage = jqXHR.responseJSON?.message ? jqXHR.responseJSON.message.trim() : "";
                toast.error("Failed to adjust dates:  " + errorMessage);
            }
        });
    };

    render() {

        return (
            <div>
                <h3 className={'ss-summary' + (this.props.display === 'popup' ? ' hidden' : '')}>
                    Adjust End Date
                </h3>
                <form className="no-padding">
                    <div className="modal-body">
                        <br/>
                        <div className="ss-fieldset-row for-hs-field">
                            <div id="searchEndDateItem"
                                 className="hs-field">
                                <label
                                    className="ss-inline-end-date-label">UNTIL</label>
                                <DatePicker id="endDate"
                                            name="endDate"
                                            value={this.state.endDate}
                                            onChange={this.handleFieldChange}
                                            width="100px"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="table text-center">
                            <button type="button"
                                    className="ss-button-primary"
                                    onClick={() => this.submitForm()}>
                                Adjust End Date
                            </button>
                            <button type="button" className="ss-button-primary"
                                    onClick={() => this.props.closeSubViewHandler()}>Cancel
                            </button>
                        </div>
                    </div>


                </form>
            </div>
        );


    }
}

export default AdjustBookingDatesForm;
